import { electronApis } from '@/features/electron-api';

import { buildFirstRunChatMessage } from './first-run-summary.message';
import { firstRunSummaryStore } from './first-run-summary.store';

import type { ChatOrigin } from '@littlebird/sdk';

const FIRST_RUN_CHAT_TITLE = 'What Littlebird learned about your work';
const FIRST_RUN_CHAT_PROMPT = 'What have you learned about my work so far?';

interface ThreadSeeder {
  createThreadFromRoutine(params: {
    title: string;
    userMessage: string;
    assistantMessage: string;
    origin: ChatOrigin;
  }): Promise<string>;
}

export async function seedFirstRunSummaryChat({
  threads,
  text,
  suggestedRoutineSlugs = [],
}: {
  threads: ThreadSeeder;
  text: string;
  suggestedRoutineSlugs?: string[];
}): Promise<string> {
  const assistantMessage = buildFirstRunChatMessage(
    text,
    suggestedRoutineSlugs
  );

  const chatId = await threads.createThreadFromRoutine({
    title: FIRST_RUN_CHAT_TITLE,
    userMessage: FIRST_RUN_CHAT_PROMPT,
    assistantMessage,
    origin: 'onboarding',
  });
  firstRunSummaryStore.markChatCreated(chatId);
  return chatId;
}

// Notify only when backgrounded and not already notified. Reads visibility +
// notified at call time (post-seed), so the decision reflects current state.
export function notifyFirstRunReady(chatId: string): void {
  if (firstRunSummaryStore.notified || document.visibilityState === 'visible') {
    return;
  }
  electronApis.lbNotifications.native.sendNotification({
    id: crypto.randomUUID(),
    title: 'Littlebird is ready',
    message: 'See what it learned about your work',
    sound: 'done',
    transient: true,
    route: { to: `/chats/${chatId}` },
  });
  firstRunSummaryStore.markNotified();
}
